import {
  EvaluationOfferLike,
  EvaluationValue,
} from '../OffersEvaluation/evaluationData';

export type {
  EvaluationValue,
  EvaluationBackendState,
  EvaluationContractLike,
  EvaluationMergedVoucher,
  EvaluationScore,
  EvaluationScores,
  EvaluationVoucherLike,
  EvaluationVoucherResponseLike,
} from '../OffersEvaluation/evaluationData';

export {
  EVALUATION_OPTIONS,
  buildMergedEvaluationVouchers,
  getDeliveryScoreColor,
  getEvaluationOption,
  getOfferVendorCompany,
  getOfferVendorEmail,
  getOfferVendorName,
  getVoucherId,
  isVoucherDelivered,
} from '../OffersEvaluation/evaluationData';

export type ResultOfferLike = EvaluationOfferLike;

export type ResultContractLike = {
  id: number;
  name?: string;
  description?: string | null;
  reference?: string | null;
  state?: number;
  winner_offer?: { share_key_id?: number | string } | null;
};

/** Returns the numeric evaluation value for an offer. */
export const getResultValue = (offer: ResultOfferLike): EvaluationValue => {
  const evaluationState = offer.evaluation?.state;

  if (evaluationState === 1 || evaluationState === 'considered') return 1;
  if (evaluationState === 2 || evaluationState === 'conditional') return 2;
  if (evaluationState === 3 || evaluationState === 'selected') return 3;
  if (evaluationState === 4 || evaluationState === 'rejected') return 4;
  if (evaluationState === 5 || evaluationState === 'priority') return 5;

  return 0;
};

/** Returns true when the offer should be shown in Results (selected or priority). */
export const isResultOffer = (offer: ResultOfferLike): boolean => {
  const value = getResultValue(offer);
  return value === 3 || value === 5;
};
